import { useGameState } from "../providers/GameStateProvider";
import {
  getHintVisibility,
  shouldHideHint,
  type HintType,
} from "../config/leveling";

/**
 * Custom hook that provides hint visibility information based on user progress
 * @returns Object with hint visibility states and helper functions
 */
export function useHintVisibility() {
  const { statsLevel } = useGameState();

  const hintVisibility = getHintVisibility(statsLevel);

  /**
   * Check if a specific hint should be hidden
   * @param hintType The type of hint to check
   * @returns true if the hint should be hidden
   */
  const isHintHidden = (hintType: HintType): boolean => {
    return shouldHideHint(hintType, statsLevel);
  };

  return {
    ...hintVisibility,
    isHintHidden,
    userLevel: statsLevel,
  };
}
